import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

// img
import i1 from "../../../../Assets/images/authbg.png";
import user from "../../../../Assets/images/user.png";
import {
  catchAsync,
  checkResponse,
  findLabelOfAccountType,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import {
  GET_USER_BY_ID,
  SERVICE_PROVIDER_VIEW,
  STATUS_CHANGE_SERVICE_PROVIDER,
  UPDATE_DOCUMENT,
} from "../../../../services/ApiCalls";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";
import ServiceProviderOrder from "./ServiceProviderOrder";
import DocumentModal from "./DocumentDisplay";
import ReportedUsers from "./ServiceProviderOrder/ReportedUsers";
import CommonConfirmModal from "../../../../components/Common/CommonConfirmModal";

const ServiceProviderDetail = () => {
  const [loader, setLoader] = useState(false);
  const [userDetails, setUserUserDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    action: null,
    status: null,
  });

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const pageName = location.pathname.split("/")[2];
  const tabs = ["appointments", "reported users"];
  console.log(pageName, "poagenmame");
  const capitalizeFirstAlphaBet = (str) =>
    str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_USER_BY_ID(id);
    checkResponse({ res, setData: setUserUserDetails, setLoader });
    setDocuments(res.data.data?.documentsList || []);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const acceptRejectHandler = catchAsync(async (status) => {
    console.log("status>>>>>", status);
    const res = await STATUS_CHANGE_SERVICE_PROVIDER({ _id: id, status });

    const success = checkResponse({
      res,
    });

    if (success) {
      navigate("/service-provider/register");
    }
  });


  const acceptRejectDocumentsHandler = catchAsync(async (status) => {
    console.log("status>>>>>", status);
    const res = await UPDATE_DOCUMENT({ _id: id, status });

    const success = checkResponse({
      res,
    });

    if (success) {
      getData()
    }
  });
  const handleModalConfirm = async () => {
    const { action, status } = confirmModal;
  
    if (action === "therapist") {
      await acceptRejectHandler(status);
      if(status==="rejected")
      {
        navigate("/service-provider/request")
      }
    }
  
    if (action === "documents") {
      await acceptRejectDocumentsHandler(status);
    }
  
    setConfirmModal({ show: false, action: null, status: null });
  };

  return (
    <>
  
      {loader && <Loader />}
      <section className="py-3 position-relative providerDetail">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to={
                    pageName === "register"
                      ? "/service-provider/register"
                      : "/service-provider/request"
                  }
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-capitalize">
                  Therapist Details
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper rounded"
                style={{ border: "1px solid #dee2e6" }}
              >
                <div className="coverImg" style={{ marginBottom: -100 }}>
                  <div className="mx-auto position-relative upload text-center">
                    <div className="imgWrp position-relative">
                      <img
                        style={{ height: 140 }}
                        src={userDetails?.bannerImage?.link || i1}
                        alt=""
                        className="img-fluid object-fit-cover w-100 rounded"
                      />
                    </div>
                  </div>
                </div>
                <Row className="justify-content-between px-lg-5 p-md-4 p-3 position-relative">
                  <Col lg="12" className="my-2">
                    <div
                      className="imgWrp text-center mx-auto"
                      style={{ maxWidth: "max-content" }}
                    >
                      <img
                        src={userDetails?.profileImage?.link || user}
                        style={{ height: 140, width: 140 }}
                        alt=""
                        className="img-fluid rounded-circle object-fit-cover"
                      />
                    </div>
                    {/* <div className="text-end">
                      <div className="d-inline-flex align-items-center gap-10">
                        <label
                          htmlFor=""
                          className="form-label m-0 text-muted fw-sbold"
                        >
                          Status
                        </label>
                        <Form.Check // prettier-ignore
                          type="switch"
                          id="custom-switch"
                          checked
                        />
                      </div>
                    </div> */}
                  </Col>
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Name :</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.fname + userDetails?.lname}
                        </h6>
                      </li>
                      {/* <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">
                          Account Type:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                         
                          {findLabelOfAccountType(userDetails?.accountType)}
                        </h6>
                      </li> */}
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Email:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.email}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Address:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.address}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Speciality:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.serviceType[0]?.catName}
                        </h6>
                      </li>
                      {/* <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">
                          Start Time:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.startTime}
                        </h6>
                      </li> */}
                    </ul>
                  </Col>
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Phone Number:</p>
                        <p className="m-0 text-muted fw-normal w-50">
                          {userDetails?.mobileNumber}
                        </p>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Created at:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {moment(userDetails?.date_created_utc).format(
                            "DD-MM-YYYY , HH:MM"
                          )}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Status:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.status === "approved"
                            ? "Active"
                            : removeUnderScoreAndCapitalizeFirstLetter(
                                userDetails?.status
                              )}
                        </h6>
                      </li>
                      {/* <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Service Type:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.status === "approved" ? "Active" : removeUnderScoreAndCapitalizeFirstLetter(userDetails?.status)}
                        </h6>
                      </li> */}
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Price Per Hour:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.pricePerHour || 0.0}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">Documents Status:</p>
                        <h6 className="m-0 text-muted fw-normal w-50">
                          {userDetails?.hasDocumentApproved}
                        </h6>
                      </li>

                      {/* <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 fw-sbold w-25">End Time:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.endTime}
                        </h6>
                      </li> */}
                    </ul>
                  </Col>
                  {
              userDetails?._id&&(
                userDetails?.documentsList?.length>0&&(
                  <Col lg="12" className="my-2">
                    <div className="d-flex align-items-center justify-content-center gap-10 pt-4">
                      <Button onClick={() => setShowModal(true)} className="d-flex align-items-center justify-content-center commonBtn GreyBtn" type="button">
                        View Documents
                      </Button>
                    </div>
                  </Col>
                )
              )
            }
                  {userDetails?.hasDocumentApproved === "pending" && (
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10 pt-4">
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                          type="button"
                          onClick={() =>
                            setConfirmModal({
                              show: true,
                              action: "documents",
                              status: "rejected",
                            })
                          }
                        >
                          Reject Documents
                        </Button>
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn "
                          type="button"
                          onClick={() =>
                            setConfirmModal({
                              show: true,
                              action: "documents",
                              status: "approved",
                            })
                          }
                        >
                          Accept Documents
                        </Button>
                      </div>
                    </Col>
                  )}
                  {userDetails?.status === "created" && (
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10 pt-4">
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                          type="button"
                          onClick={() =>
                            setConfirmModal({
                              show: true,
                              action: "therapist",
                              status: "rejected",
                            })
                          }
                        >
                          Reject Therapist
                        </Button>
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn "
                          type="button"
                          onClick={() =>
                            setConfirmModal({
                              show: true,
                              action: "therapist",
                              status: "approved",
                            })
                          }
                        >
                          Accept Therapist
                        </Button>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </Col>
            
            
            {userDetails?._id && (
              
              <Tab.Container defaultActiveKey="appointments">
              <Nav
              variant="pills"
              className="inline-flex rounded-pill pillsTab"
              style={{ background: "#1C2E4F", maxWidth: "max-content" }}
            >
              {tabs.map((tab) => (
                <Nav.Item key={tab}>
                  <Nav.Link
                    className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                    eventKey={tab}
                  >
                    {capitalizeFirstAlphaBet(tab)}
                  </Nav.Link>
                </Nav.Item>
              ))}

            </Nav>
             <Tab.Content >
             <Tab.Pane eventKey="appointments">
             <ServiceProviderOrder userId={userDetails?._id} />
               {/* Your component can go here */}
             </Tab.Pane>


             <Tab.Pane eventKey="reported users">
             <ReportedUsers userId={userDetails?._id} />
               {/* Your component can go here */}
             </Tab.Pane>

            </Tab.Content>

            </Tab.Container>
            )}
          </Row>
        </Container>
        <DocumentModal
        show={showModal}
        onHide={() => setShowModal(false)}
        images={documents}
        
      />
      <CommonConfirmModal
  show={confirmModal.show}
  onHide={() => setConfirmModal({ show: false })}
  title={`Confirm ${confirmModal.status?.toUpperCase()}`}
  message={`Are you sure you want to ${confirmModal.status} this ${
    confirmModal.action === "therapist" ? "therapist" : "documents"
  }?`}
  confirmText={`Yes, ${confirmModal.status}`}
  onConfirm={handleModalConfirm}
/>
      </section>
    </>
  );
};

export default ServiceProviderDetail;
